import AntdInput from './AntdInput';
import { WithTrim } from './utils';
const WITHREF = true;
const { Group, Search, TextArea, Password } = AntdInput;
const InternalInput = WithTrim(AntdInput, 'input', WITHREF);
const Input = InternalInput;
Input.TextArea = WithTrim(TextArea, 'input-textarea', WITHREF);
Input.Password = WithTrim(Password, 'input-password', WITHREF);
Input.Search = WithTrim(Search, 'input-search', WITHREF);
Input.Group = Group;
Input.displayName = 'Input';
Input.TextArea.displayName = 'TextArea';
Input.Password.displayName = 'Password';
Input.Search.displayName = 'Search';
Input.Group.displayName = 'Group';
export default Input;
